import { fromUnixTime, getUnixTime } from "date-fns";

const SecondsInWeek = 7 * 24 * 60 * 60;

export function getContractUnlockDate(date: Date) {
  const t = getUnixTime(date);
  const rounded = Math.floor(t / SecondsInWeek) * SecondsInWeek;
  return fromUnixTime(rounded);
}
